<script setup lang="ts">
import type { ReadonlyDeep } from 'type-fest';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import ReportGenerateDialogHeader from '@/components/headers/ReportGenerateDialogHeader.vue';
import PageDialogWrapper from '@/components/wrappers/PageDialogWrapper.vue';

export interface Props {
  image?: ReadonlyDeep<openapi.GetStopImagesContentOpenapi[0][0]>;
}
export type DefProps = typeof props;
const props = withDefaults(defineProps<Props>(), {
  image: undefined,
});
const emit = defineEmits<{
  cancelBtnClick: [event: Event];
}>();

function handleCancelClick(event: Event): void {
  emit('cancelBtnClick', event);
}
</script>

<template>
  <PageDialogWrapper
    :class="$style.detailedJobPhotoDialog"
    data-testid="detailedJobPhotoDialog"
  >
    <template #header>
      <ReportGenerateDialogHeader @close-click="handleCancelClick">
        Preview {{ props.image?.ref }}
      </ReportGenerateDialogHeader>
    </template>
    <section ref="main" :class="$style.main">
      <template v-if="props.image?.path">
        <v-img
          :class="$style.img"
          :src="image.path"
          max-width="480"
          max-height="540"
          cover
        >
        </v-img>
      </template>
    </section>
  </PageDialogWrapper>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.detailedJobPhotoDialog {
  width: 545px;
}
  .main {
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
